import type {
  BatchUpdateLlgPoliciesRequest,
  Configuration,
  SearchLogsHistogramInput,
  SearchLogsInput,
} from '@repo/api-gw-sdk';
import {
  LlgPoliciesApi,
  LogSourcesApi,
  LogSourcesPoliciesApi,
  SearchApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/logs';

export const logs = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const searchApi = new SearchApi(config);
  const logSourcesApi = new LogSourcesApi(config);
  const logSourcesPoliciesApi = new LogSourcesPoliciesApi(config);
  const llgPoliciesApi = new LlgPoliciesApi(config);

  return {
    useListSchemas: (resourceIds: string[]) =>
      httpClient.execute(
        searchApi.getLogsSchemas.bind(searchApi),
        baseUrl,
        '/schemas',
        currentProjectId,
        resourceIds
      ),
    useSearch: (
      searchLogsInput: SearchLogsInput,
      disableExecution?: boolean
    ) => {
      return httpClient.executeWithConfig(
        searchApi.searchLogs.bind(searchApi),
        searchLogsInput.resourceIds.length && !disableExecution
          ? baseUrl
          : null,
        '/search',
        {
          dedupingInterval: 120_000,
        },
        currentProjectId,
        searchLogsInput
      );
    },
    useSources: () =>
      httpClient.execute(
        logSourcesApi.listLogSources.bind(logSourcesApi),
        baseUrl,
        '/sources',
        currentProjectId
      ),
    policies: {
      useList: (pageIndex?: number, pageSize?: number) =>
        httpClient.execute(
          logSourcesPoliciesApi.listLogSourcesPolicies.bind(
            logSourcesPoliciesApi
          ),
          baseUrl,
          '/policies',
          currentProjectId,
          pageIndex,
          pageSize
        ),
      update: (batchUpdateLlgPoliciesRequest: BatchUpdateLlgPoliciesRequest) =>
        llgPoliciesApi.batchUpdateLlgPolicies(
          currentProjectId,
          batchUpdateLlgPoliciesRequest
        ),
    },
    useHistogram: (input: SearchLogsHistogramInput) =>
      httpClient.execute(
        searchApi.getLogsHistogram.bind(searchApi),
        input.resourceIds.length ? baseUrl : null,
        '/histogram',
        currentProjectId,
        input
      ),
  };
};
